import { createSlice } from "@reduxjs/toolkit";

const getInitialWish = () => {
  const storedWish = localStorage.getItem("wishlist");
  return storedWish ? JSON.parse(storedWish) : [];
};

const WishSlice = createSlice({
  name: "Wish",
  initialState: {
    wish: getInitialWish(),
  },
  reducers: {
    addToWish: (state, action) => {
      const exists = state.wish.find(item => item._id === action.payload._id);
      if (!exists) {
        state.wish.push(action.payload);
        localStorage.setItem("wishlist", JSON.stringify(state.wish)); // Save
      }
    },

    removeFromWish: (state, action) => {
      state.wish = state.wish.filter(item => item._id !== action.payload._id);
      localStorage.setItem("wishlist", JSON.stringify(state.wish)); // Save
    },

    initializeWish: (state, action) => {
      state.wish = action.payload;
      localStorage.setItem("wishlist", JSON.stringify(action.payload)); // Save
    },
  },
});


export const {addToWish,removeFromWish,initializeWish} = WishSlice.actions;

export default WishSlice.reducer;
